import React, { ReactNode } from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classes from './InfoContainer.module.scss';

type InfoContainerProps = {
  children: ReactNode;
};

const InfoContainer = ({ children }: InfoContainerProps) => {
  return <Surface className={classes.box}>{children}</Surface>;
};

export { InfoContainer };
